import consumer from "./consumer"

consumer.subscriptions.create("AiAgentResponseChannel", {
  connected() {
    console.log("Connected to AiAgentResponseChannel")
  },

  received(data) {

    // ---------------------------
    // IMAGE HANDLING
    // ---------------------------
    if (data.type === "image") {
      handleImageResponse(data)
      return
    }

    // ---------------------------
    // EXISTING TEXT HANDLING
    // ---------------------------
    var dataBlockId = data.block_id
    var taskId = data.task_id
    var projectId = data.project_id
  
    var task_spinner = document.querySelector(
      `.task-ai-process-spinner-${taskId}`
    )
    var ai_loading_indicator = document.querySelector(`.ai-loading-indicator-${dataBlockId}`)
    var project_ai_loading_indicator = document.querySelector(`.project-ai-loading-indicator-${projectId}`)
    var content = document.querySelector(`.ai-content-${dataBlockId}`)

    if (data.content && content) {
      content.innerHTML += data.content
    }


    if (data.done) {
      if (content) {
        content.innerHTML = data.updated_description
      }
      if (task_spinner) task_spinner.style.display = "none"
      if (ai_loading_indicator) ai_loading_indicator.style.display = "none"
      if (project_ai_loading_indicator) project_ai_loading_indicator.style.display = "none"
      updateReferencingRichTextFields(dataBlockId, taskId)
    }

    if (!data.done) {
      if (task_spinner) task_spinner.style.display = ""
      if (ai_loading_indicator) ai_loading_indicator.style.display = ""
      if (project_ai_loading_indicator) project_ai_loading_indicator.style.display = ""
    }
  }
})

function updateReferencingRichTextFields(blockId, taskId) {
  
  var taskElement = document.querySelector(`li#task_${taskId}`)
  if (!taskElement) {
    return
  }

  var accountId = taskElement.dataset.accountId
  var projectId = taskElement.dataset.projectId
  var taskListId = taskElement.dataset.taskListId

  
  if (!accountId || !projectId || !taskListId) {
    var pathParts = window.location.pathname.split('/').filter(part => part.length > 0)
    var accountIndex = pathParts.indexOf('projects') - 1
    var projectIndex = pathParts.indexOf('projects') + 1
    var taskListIndex = pathParts.indexOf('task_lists') + 1

    if (accountIndex >= 0 && pathParts[accountIndex]) {
      accountId = accountId || pathParts[accountIndex]
    }
    if (projectIndex >= 0 && pathParts[projectIndex]) {
      projectId = projectId || pathParts[projectIndex]
    }
    if (taskListIndex >= 0 && pathParts[taskListIndex]) {
      taskListId = taskListId || pathParts[taskListIndex]
    }
  }

  
  if (!accountId || !projectId || !taskListId) {
    var stepElement = taskElement.querySelector('.step')
    if (stepElement) {
      accountId = accountId || stepElement.dataset.accountId
      projectId = projectId || stepElement.dataset.projectId
      taskListId = taskListId || stepElement.dataset.taskListId
    }
  }

  if (accountId && projectId && taskListId && taskId && blockId) {
    
    var url = `/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/render_referencing_task_blocks`
    
    if (typeof Rails !== 'undefined' && Rails.ajax) {
      Rails.ajax({
        url: url,
        type: 'GET',
        dataType: "script"
      })
    } else {
     
      fetch(url, {
        method: 'GET',
        headers: {
          'Accept': 'text/javascript',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        },
        credentials: 'same-origin'
      })
      .then(response => response.text())
      .then(script => {
        eval(script)
      })
      .catch(error => {
        console.error("Error updating referencing blocks:", error)
      })
    }
  }
}
